import * as amplitude from '@amplitude/analytics-browser'
import { stripNonceFromUrl } from './urlUtils'

// Amplitude records the full href on these properties, and a portal link carries a
// single-use nonce that must not leave the browser inside an analytics payload.
const urlEventProperties = ['[Amplitude] Page Location', 'referrer']

const scrubNonceFromUrls = (eventProperties: Record<string, unknown>) => {
    const scrubbed = { ...eventProperties }
    urlEventProperties.forEach((property) => {
        const value = scrubbed[property]
        if (typeof value === 'string') scrubbed[property] = stripNonceFromUrl(value)
    })
    return scrubbed
}

let ownerId: string | undefined

export const setTrackingOwnerId = (nextOwnerId: string | undefined) => {
    ownerId = nextOwnerId
}

export const ownerIdEnrichmentPlugin = () =>
    ({
        name: 'portal-owner-id-enrichment',
        type: 'enrichment',
        execute: async (event: amplitude.Types.Event) => {
            if (!ownerId) return event
            return { ...event, event_properties: { ...event.event_properties, ownerId } }
        }
    }) satisfies amplitude.Types.EnrichmentPlugin

export const nonceScrubbingPlugin = () =>
    ({
        name: 'portal-nonce-scrubbing',
        type: 'enrichment',
        execute: async (event: amplitude.Types.Event) => {
            if (!event.event_properties) return event
            return { ...event, event_properties: scrubNonceFromUrls({ ...event.event_properties }) }
        }
    }) satisfies amplitude.Types.EnrichmentPlugin
